export const SET_WINDOW_SIZE = "SET_WINDOW_SIZE";
export const SET_IS_DRAFT_PANEL_OPEN = "SET_IS_DRAFT_PANEL_OPEN";
export const SET_CLIENT_SETTINGS = "SET_CLIENT_SETTINGS";
